module.exports = __webpack_public_path__ + "img/carC7.3b9a6e77.png";